const initialState = {
  qty: null,
  items: [],
  insider: {},
};
 
const actions = {
  SET_PRODUCT_ITEM_QTY: 'PDP/SET_PRODUCT_ITEM_QTY',
  SET_PRODUCT_ITEM_QTY_MULTIPLE: 'PDP/SET_PRODUCT_ITEM_QTY_MULTIPLE',
  SET_INSIDER: 'PDP/SET_INSIDER',
};
 
export const PdpReducer = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }
  if (action.type === actions.SET_PRODUCT_ITEM_QTY) {
    if (action.payload?.item_id) {
      let finalItems = state?.items;
      if (action.payload?.qty <= 0) {
        finalItems = finalItems?.filter((item) => item?.item_id !== action.payload?.item_id);
      } else if (state?.items?.some((item) => item?.item_id === action.payload?.item_id)) {
        finalItems = [
          ...state?.items?.map((item) => (item?.item_id === action.payload?.item_id ? action.payload : item)),
        ];
      } else {
        finalItems = [...state?.items, action.payload];
      }
 
      return {
        ...state,
        qty: action.payload?.qty,
        items: finalItems,
      };
    }
    return { ...state };
  }
  if (action.type === actions.SET_PRODUCT_ITEM_QTY_MULTIPLE) {
    if (action.payload?.items) {
      const finalItems = action.payload?.items?.map((item) => ({ item_id: item?.item_id, qty: item?.qty, price: item?.price }));
 
      return {
        ...state,
        items: finalItems,
      };
    }
    return { ...state };
  }
  if (action.type === actions.SET_INSIDER) {
    if (action.payload?.insider) {
      return {
        ...state,
        insider: {...state?.insider , ...action.payload?.insider},
      };
    }
  }
  return state;
};
 
export const setProductItemQty = (itemId, qty) => ({
  type: actions.SET_PRODUCT_ITEM_QTY,
  payload: { item_id: itemId, qty },
});
 
export const setProductItemQtyMultiple = (items) => ({
  type: actions.SET_PRODUCT_ITEM_QTY_MULTIPLE,
  payload: { items },
});
 
export const setInsiderObj = (insider) => ({
  type: actions.SET_INSIDER,
  payload: { insider },
});
 
export default PdpReducer
